jQuery(function($){
    $(document).on('click','button.add_to_cart.global-button.global-button--primary.ajax-submit', function(e){
              $('.js-menu__context').addClass('js-menu__expanded');
              $('body').addClass('js-menu-open');
              $('html').addClass('over-hidden');
              $('.js-menu--right').addClass('js-menu__expanded');
    });
    $(document).on('click','.quick-cart__trigger', function(e){
         e.preventDefault();
              $('.js-menu__context').toggleClass('js-menu__expanded');
              $('body').toggleClass('js-menu-open');
              $('html').toggleClass('over-hidden');
              $('.js-menu--right').toggleClass('js-menu__expanded');
    });
    $(document).on('click','.js-menu__context, .js-menu__close', function(event){
            if ( $(event.target).hasClass('js-menu__context') || $(event.target).hasClass('js-menu__close') ) {
                 $('.js-menu__expanded').removeClass('js-menu__expanded');
                 $('body').removeClass('js-menu-open');
                 $('html').removeClass('over-hidden');
            }
    });
    $('button.add_to_cart.ajax-submit.cm-rec-pro-cta').click( function(e){
              $('.js-menu__context').addClass('js-menu__expanded');
              $('body').addClass('js-menu-open');
              $('html').addClass('over-hidden');
              $('.js-menu--right').addClass('js-menu__expanded');
    });
    $('.cm-rec-prod-cta-content li button').click(function(){
    $('.cm-rec-prod-cta-content').removeClass('show-options');
    }); 
    $(document).on('click','.free-gift-item', function(){
      $(this).closest('.cart-free-gift-item-info-rgt').find('.free-prod-cta-content').addClass('show-options');
      //$('body').addClass('free-gift-product-visible');
    });
    $(document).on('click','.free-prod-cta-content li', function(){
      $(this).addClass('selected-option').siblings().removeClass('selected-option');
      let variantId = $(this).attr('data-variantid');
    });
    $('.free-prod-cta-content li button').click(function(){
      $('.free-prod-cta-content').removeClass('show-options');
      $('.cart-free-gift-items').addClass('remove-freebe');
    }); 
    $('.outer-new-wraper-box').click(function(){
      $('.free-prod-cta-content').removeClass('show-options');
    });
    $('a.js-cart-remove-btn.cart__remove-btn.free-gift-remove').click(function(){
      $('.cart-free-gift-items').removeClass('remove-freebe');
    }); 

/******************************Cart drawer functionality******************************/
if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
  applyDiscount();
   var checkFreeDiscoutOfferEnabled = $('#cart-settings-data').attr('data-activefreeoffer');
   var freeShippingItemCount = 3;
   var freeShippingAppliedText = `Congrats, you just received free shipping!`;
   var freeShippingTextHint = `You are 1 pack away from free shipping!`;
   var discountAppliedText = `Congrats, you just received discountPercentage% off!`;
   var noDiscountHintText = `You’re all set. Continue to shop or proceed to checkout!`;
   var tier_1_line_qnty = 3;
   var tier_2_line_qnty = 6;
   var tier_3_line_qnty = 8;
   var tier_1_dis_amount = 0.99;
   var tier_2_dis_amount = 3.66;
   var tier_3_dis_amount = 4.49;  
   var tier_1_dis_amount2 = 35;
   var tier_2_dis_amount2 = 55;
   var tier_3_dis_amount2 = 90;
   var Progress_bar_content_1 = `$40`;
   var Progress_bar_content_2 = `$50`;
   var Progress_bar_content_3 = `$60`;
  
   var getfree_type = ``;

$(document).on('click', '.custom-addtocart', function (e) {
    var $btn = $(this);
    var variantId = $btn.attr('data-variant-ids');
    if (variantId) {
        matchedVariantId = variantId;
        addToCart(matchedVariantId);
        return;
    }
});


function addToCart(matchedVariantId) {
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        id: matchedVariantId,
        quantity: 1
      },
      success() {
        // ... your existing success logic remains unchanged
        $.ajax({
          url: '/cart.js',
          dataType: 'json',
          cache: false,
          success(cart) {
            // existing cart refresh logic...
            setTimeout(function () {
              refreshCart(cart);
              $('.custom-addtocart').removeClass('add-checkmark');
              $('.new-mini-cart-icon.quick-cart__trigger').click();

              if ($('body').hasClass('fancybox-active')) {
                $.fancybox.close();
              }

              if ($('#header').is(':visible')) {
                $('#header .cart-container, header[data-desktop-header]').addClass('active_link');
              } else if ($('.sticky_nav--stick').length) {
                $('.sticky_nav .cart-container, header[data-desktop-header]').addClass('active_link');
              } else {
                $('.top-bar .cart-container, header[data-desktop-header]').addClass('active_link');
              }

              // Scroll behavior on mobile
              if (window.PXUTheme.media_queries.medium.matches) {
                const $cartContainer = $(this).parent();
                $('body').addClass('blocked-scroll');

                const header = document.getElementById('header');
                if (header.classList.contains('mobile_nav-fixed--false')) {
                  window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                }
              }
            }, 500);

            setTimeout(function () {
              $('.js-menu__context').removeClass('js-menu__expanded');
              $('body').removeClass('js-menu-open');
              $('html').removeClass('over-hidden');
              $('.js-menu--right').removeClass('js-menu__expanded');
            }, 4000);
          },
        });
      }
    });
}
   
   $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      var $currentAjaxBtn = $(this);
      var $variantId = $(this).attr('data-selected-variant');
      var $addToCartBtn = $(this).closest('.cm-rec-prod-cta-wrapper').find('.add_to_cart');
      if($(this).hasClass('free-gift-item')){
        $('body').addClass('loader-on');
          var ajaxData = {
            quantity: 1,
            id: $variantId,
            properties: {
              "freeShippingItemCount": $('body').attr('data-free-product-count'),
              "productType": "free",
              "discountAmount": $(this).attr('data-amount')
            }

          }
       
        }else if($(this).hasClass('cm-rec-pro-cta')){
          var ajaxData = {
            quantity: 1,
            id: $variantId,
          }
      }else{
        var $addToCartForm = $(this).closest('form');
        var $addToCartBtn = $addToCartForm.find('.add_to_cart');
        var ajaxData = $addToCartForm.serialize();
      }
     

      // Refresh page on quick shop add to cart if on cart page
      if ($('body').hasClass('cart')) {
        $addToCartForm.submit();
      }

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: ajaxData, //$addToCartForm.serialize(),
        beforeSend() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success() {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');
          if($currentAjaxBtn.hasClass('cm-rec-pro-cta')){
            $('.cm-rec-prod-cta-wrapper .cm-rec-prod-cta-content').addClass('cm-item-added'); //show-options ;
            $currentAjaxBtn.closest('li').addClass('selected-option');
        }

          window.setTimeout(() => {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
            if($currentAjaxBtn.hasClass('cm-rec-pro-cta')){
                $('.cm-rec-prod-cta-wrapper .cm-rec-prod-cta-content').removeClass('cm-item-added'); //show-options ;
                $currentAjaxBtn.closest('li').removeClass('selected-option');
            }
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              setTimeout(function () {

                refreshCart(cart);
                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }

                if ($('#header').is(':visible')) {

                  $('#header .cart-container, header[data-desktop-header]').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {

                  $('.sticky_nav .cart-container, header[data-desktop-header]').addClass('active_link');
                } else {

                  $('.top-bar .cart-container, header[data-desktop-header]').addClass('active_link');
                }

                // block scrolling on mobile
                if (window.PXUTheme.media_queries.medium.matches) {
                  const $cartContainer = $(this).parent();
                  if ($cartContainer.hasClass('active_link')) {
                    $('body').addClass('blocked-scroll');
                  } else {
                    $('body').addClass('blocked-scroll');
                  }

                  // Scroll to the top of the page unless the header is fixed
                  const header = document.getElementById('header');
                  if (header.classList.contains('mobile_nav-fixed--false')) {
                    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                  }
                }
              }, 500);
            },
          });
        },
        error(XMLHttpRequest) {
          //console.log($addToCartBtn, 'XMLHttpRequest==>', XMLHttpRequest);
          let response = eval(`(${XMLHttpRequest.responseText})`);
          response = response.description;
          $('.warning').remove();
          if(XMLHttpRequest.status == '422') {
            $('body').removeClass('loader-on');

            var attrFreeGiftProd = $currentAjaxBtn.attr('data-free-gift-product-cta');

            // For some browsers, `attr` is undefined; for others, `attr` is false. Check for both.
            if (typeof attrFreeGiftProd !== typeof undefined && attrFreeGiftProd !== false) {
              // Element has this attribute
              $(document).find('[data-free-gift-product-cta]').closest('.cart-free-gift-item-info').append('<p class="removeAddtoCartWarningMsg">'+response+'</p>')
            }
            
            setTimeout( ()=>{
              $(document).find('.removeAddtoCartWarningMsg').remove();
            }, 10000);
            

          }
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
          
        },
      });

      return false;
    });
    
    function refreshCart(cart) {
        $('.cart_count').empty();
        const $cartBtn = $('.cart_count');
        const value = $cartBtn.text() || '0';
        let cartItemsHTML = '';
        let cartDiscountsHTML = '';
        let cartActionHTML = '';
        let cartSavingsHTML = '';
        const $cartForm = $('[data-cart-form]');
        let productHasSale = false;
        let productCompareAtPrice = 0;
        let productFinalPrice = 0;
        $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));
        if (cart.item_count === 0) {
          $('.js-empty-cart__message').removeClass('hidden');
          $('footer.quick-cart__footer1.js-footer11').addClass('hide');
          $cartForm.addClass('hidden');
        } else {
          $('.js-empty-cart__message').addClass('hidden');
          $('footer.quick-cart__footer1.js-footer11').removeClass('hide');
          $cartForm.removeClass('hidden');
          $.each(cart.items, (index, item) => {
                const lineID = index + 1;
                // Initialize the class variable
                let additionalClass = '';
                // Check if item.product and item.product.tags are defined and tags is an array
                if (item.product_type == 'belts' || item.product_type == 'Movement Series' || item.product_type == 'Shoelace Accessories' || item.product_type == 'Belts Accessories') {
                    additionalClass = 'nodiscount';
                }else if (item.product_type == 'Freebe-item' || item.product_type == 'Xpand Quick Wipes' || item.product_type == 'thirdFreebe-item' || item.product_type == 'fourthFreebe-item'){
                    additionalClass = 'free-gift-item';
                }else if (item.product_type == 'Extra 5% Savings'){
                    additionalClass = 'nodiscount pack-saving-gift';
                }else if (item.product_type == 'Gift Card'){
                    additionalClass = 'nodiscount card-gift';
                }else{
                    additionalClass = 'discount';
                }
                if (item.product_type == 'Freebe-item' || item.product_type == 'Xpand Quick Wipes' || item.product_type == 'thirdFreebe-item' || item.product_type == 'fourthFreebe-item'){
                  cartItemsHTML += `<li class="mini-cart__item ${additionalClass} ${item.product_type}" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}" data-key="${item.key}">`;
                }else{
                  cartItemsHTML += `<li class="mini-cart__item ${additionalClass}" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}" data-key="${item.key}">` + `<a href="${item.url}">`;
                }
                if (item.image) {
                  if (item.product_type == 'Freebe-item' || item.product_type == 'Xpand Quick Wipes' || item.product_type == 'thirdFreebe-item' || item.product_type == 'fourthFreebe-item'){
                    cartItemsHTML += `${'<div class="cart_image">'
                      + '<img class="mini-cart__item--img" data-url="'+item.image+'" src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />`
                    + '</div>';
                  }else{
                  cartItemsHTML += `${'<div class="cart_image">'
                      + '<img class="mini-cart__item--img" data-url="'+item.image+'" src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />`
                    + '</div></a>';
                  }
                }
                if (item.product_type == 'Freebe-item' || item.product_type == 'Xpand Quick Wipes' || item.product_type == 'thirdFreebe-item' || item.product_type == 'fourthFreebe-item'){
                   cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart-new-box"><div class="mini-cart__item-title estt"><a>${item.product_title}</a>`;
                }else{
                   cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart-new-box"><div class="mini-cart__item-title estt"><a href="${item.url}">${item.product_title}</a>`;                  
                }
                if (item.variant_title) {
                  cartItemsHTML += `<span class="mini-cart__item-variant__title">${item.variant_title}</span>`;
                }

                if(item.product_type == 'Extra 5% Savings'){
                  cartItemsHTML += `</div><div class="mini-cart__item-price package-pricing" data-original-price="${window.Shopify.formatMoney(item.original_price, $('body').data('money-format'))}">`;
                const itemPrice = window.Shopify.formatMoney(item.price, $('body').data('money-format'));
                  if (item.price > 0) {
                    cartItemsHTML += `<span data-upate-price="`+item.price+`" data-price="`+item.price+`" data-original-price="`+item.price+`" class="money apnatvv">${itemPrice}</span><span class="apnatvv strkprcc pack-updated-gg" data-pack-updated-gg="3597">$35.97</span></strong>`;
                  } else {
                    cartItemsHTML += `<span>Free</span></strong>`;
                  }
                }else{
                cartItemsHTML += `</div><div class="mini-cart__item-price" data-original-price="${window.Shopify.formatMoney(item.original_price, $('body').data('money-format'))}">`;
                const itemPrice = window.Shopify.formatMoney(item.price, $('body').data('money-format'));
                  if (item.price > 0) {
                    cartItemsHTML += `<span data-upate-price="`+item.price+`" data-price="`+item.price+`" data-original-price="`+item.price+`" class="money apnatvv">${itemPrice}</span><span class="apnatvv strkprcc" style="display:none"></span></strong>`;
                  } else {
                    cartItemsHTML += `<span>Free</span></strong>`;
                  }
                }

                cartItemsHTML += '</div>';
                if (item.unit_price_measurement && item.price > 0) {
                  let unitPriceMeasurementReferenceValue = '';
                  if (item.unit_price_measurement.reference_value !== 1) {
                    unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
                  }
                  cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
                }
                if (item.product_type == 'Freebe-item' || item.product_type == 'Xpand Quick Wipes' || item.product_type == 'thirdFreebe-item' || item.product_type == 'fourthFreebe-item'){
                  cartItemsHTML += '<div class="product-quantity-new-outer"><div class="product-box">';
                  cartItemsHTML += `<input type="number" class="freebequantity" value="1" style="pointer-events:none"/>`;
                  cartItemsHTML += '</div>';
                  cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn free-gift-remove" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"><svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.77778 3.96297L4.43762 16.1351C4.50518 16.6306 4.92838 17 5.42845 17H12.5312C13.0484 17 13.4803 16.6056 13.5271 16.0905L14.6296 3.96297M16.4074 3.96297H1" stroke="#B5B5B5" stroke-linecap="round"/>
                <path d="M5.74121 3.37037V2C5.74121 1.44772 6.18893 1 6.74121 1H10.6671C11.2194 1 11.6671 1.44772 11.6671 2V3.37037" stroke="#B5B5B5" stroke-linecap="round"/>
                </svg>
                </span></a>`;
                  cartItemsHTML += '</div>';
                }else{
                cartItemsHTML += '<div class="product-quantity-new-outer"><div class="product-quantity-box">';
                cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
                cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
                cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
                cartItemsHTML += '</div>';
                cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"><svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.77778 3.96297L4.43762 16.1351C4.50518 16.6306 4.92838 17 5.42845 17H12.5312C13.0484 17 13.4803 16.6056 13.5271 16.0905L14.6296 3.96297M16.4074 3.96297H1" stroke="#B5B5B5" stroke-linecap="round"/><path d="M5.74121 3.37037V2C5.74121 1.44772 6.18893 1 6.74121 1H10.6671C11.2194 1 11.6671 1.44772 11.6671 2V3.37037" stroke="#B5B5B5" stroke-linecap="round"/></svg></span></a>`;
                cartItemsHTML += '</div></div>';
                }
          });
          cartActionHTML += `<span class="right cart_subtotal_price_wapper"><span data-pp="1" data-subtotal-cart-original="`+cart.original_total_price+`" data-sutotal-price="`+cart.original_total_price+`" class="money">${window.Shopify.formatMoney(cart.original_total_price, $('body').data('money-format'))}</span></span>`;
          cartSavingsHTML = '';
        }
        $('.js-cart_items').html(cartItemsHTML);
        $('.js-cart_subtotal').html(cartActionHTML);
        $('.main-subtotal-price .main-price').html(cartActionHTML); 
        $('.main-subtotal-price').hide();
        updatediscountbar(cart);
        updateshippingbar(cart);        
        freebeavaiability(cart);

        const hasFirst = $('li.mini-cart__item.free-gift-item.thirdFreebe-item').length > 0;
        const hasSecond = $('li.mini-cart__item.free-gift-item.fourthFreebe-item').length > 0;
        const hasThird = $('li.mini-cart__item.free-gift-item.Freebe-item').length > 0;
        const hasFourth = $('li.mini-cart__item.free-gift-item.Xpand.Quick.Wipes').length > 0;

        // If only the first gift is present
        if (hasFirst && !hasSecond && !hasThird && !hasFourth) {
            $('.cart-free-gift-items.first-freeproduct').addClass('remove-freebe');
            $('.cart-free-gift-items.second-freeproduct').removeClass('remove-freebe');
            $('.cart-free-gift-items.third-freeproduct').addClass('remove-freebe');
            $('.cart-free-gift-items.fourth-freeproduct').addClass('remove-freebe');
            $('h3.freebe-title').show();
        }else if (hasSecond && !hasFirst && !hasThird && !hasFourth) {
            $('.cart-free-gift-items.first-freeproduct').removeClass('remove-freebe');
            $('.cart-free-gift-items.second-freeproduct').addClass('remove-freebe');
            $('.cart-free-gift-items.third-freeproduct').removeClass('remove-freebe');
            $('.cart-free-gift-items.fourth-freeproduct').addClass('remove-freebe');
            $('h3.freebe-title').show();
        }else if (!hasFirst && hasSecond && hasThird && !hasFourth ) {
            $('.cart-free-gift-items.first-freeproduct').removeClass('remove-freebe');
            $('.cart-free-gift-items.second-freeproduct').addClass('remove-freebe');
            $('.cart-free-gift-items.third-freeproduct').addClass('remove-freebe');
            $('.cart-free-gift-items.fourth-freeproduct').addClass('remove-freebe');
            $('h3.freebe-title').show();
        }else if (hasFirst && hasSecond && !hasThird) {
            $('.cart-free-gift-items.first-freeproduct').addClass('remove-freebe');
            $('.cart-free-gift-items.second-freeproduct').addClass('remove-freebe');
            $('.cart-free-gift-items.third-freeproduct').removeClass('remove-freebe');
            $('.cart-free-gift-items.fourth-freeproduct').addClass('remove-freebe');
            $('h3.freebe-title').show();
        }else if (hasFirst && hasSecond && hasThird && !hasFourth) {
            $('.cart-free-gift-items.first-freeproduct').addClass('remove-freebe');
            $('.cart-free-gift-items.second-freeproduct').addClass('remove-freebe');
            $('.cart-free-gift-items.third-freeproduct').addClass('remove-freebe');
            $('.cart-free-gift-items.fourth-freeproduct').removeClass('remove-freebe');
            $('h3.freebe-title').show();
        }else if (hasFirst && hasSecond && hasThird && hasFourth) {
            $('.cart-free-gift-items.first-freeproduct').addClass('remove-freebe');
            $('.cart-free-gift-items.second-freeproduct').addClass('remove-freebe');
            $('.cart-free-gift-items.third-freeproduct').addClass('remove-freebe');
            $('.cart-free-gift-items.fourth-freeproduct').addClass('remove-freebe');
            $('h3.freebe-title').hide();
        }

        // Check which free gift items are in the cart
        const giftcrd = $('.card-gift').length > 0;
        const giftcrd2 = $('.nodiscount').length > 0;
        const giftcrd3 = $('.discount').length > 0;

        if (giftcrd && giftcrd2 && giftcrd3) {
          $('.freebe-title').show();
          $('.cart-free-gift-wrapper').show();
          $('.shipping-progress').show();
        }else if (giftcrd2 && giftcrd3) {
          $('.freebe-title').show();
          $('.cart-free-gift-wrapper').show();
          $('.shipping-progress').show();
        } else if(giftcrd) {
          $('.freebe-title').hide();
          $('.cart-free-gift-wrapper').hide();
          $('.shipping-progress').hide();
        }


    if (window.PXUTheme.currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }
    applyDiscount(cart);
   }
  
   $('body').on('change', '[data-cart-quantity-input]', function () {
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: $(this).val(),
      parentCartForm: $(this).parents('[data-cart-form]'),
      $element: $(this).parents('[data-cart-item]'),
    };
    // Disable button after click to prevent multiple clicks
    $(this).parents('.product-quantity-box').find('.js-change-quantity').addClass('is-disabled');
    updateCartItemQuantity(cartItem);
  });
  $('body').on('click', '[data-remove-item]', function (e) {
    e.preventDefault();
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: 0,
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]'),
    };
    cartItem.$element.addClass('animated fadeOutLeft');
    updateCartItemQuantity(cartItem);

    if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
      cartItem.$element.find('input').val('0');
      cartItem.parentCartForm.submit();
    }

    if (cartItem.parentCartForm.data('cart-form') === 'mini-cart') {
      cartItem.$element.find('input').val('0');
    }
    
  });
  function updateCartItemQuantity(cartItem) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        quantity: cartItem.quantity,
        line: cartItem.lineID,
      },
      success(data) {
        const cartItemsArray = data.items;
        const lineIDIndex = cartItem.lineID - 1;
        const totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
        const $quantityInputs = cartItem.parentCartForm.find(`[data-variant-id="${cartItem.variantID}"] input`);
        let initialQuantityTotal = 0;
        let apiQuantityTotal = 0;
        const apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;

        // Check if item has a "Buy X get Y" deal
        if ($quantityInputs.length > 1) {
          // Multiple inputs

          // Get all the quantities of same variants in the cart (including BOGO) in HTML
          $.each($quantityInputs, (_i, input) => {
            initialQuantityTotal += parseInt($(input).val());
          });

          // Get quantities from cart object returned from API
          cartItemsArray.forEach(item => {
            if (item.variant_id === cartItem.variantID) {
              apiQuantityTotal += item.quantity;
            }
          });
        } else {
          // Single input
          initialQuantityTotal = parseInt($quantityInputs.val());
          apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
        }

        // Checks to see if there is enough inventory to update to an increased amount
        if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
          $('.warning--quantity').remove();
          // Check if Buy one get one product
          if (totalCartItems < cartItemsArray.length) {
            if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
              // Refreshes cart if inventory is available
              cartItem.parentCartForm.submit();
            } else {
              refreshCart(data);
            }
          } else {
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).val(apiLineItemQuantity);
          }
        } else if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
          cartItem.parentCartForm.submit();
        } else {
          refreshCart(data);
        } 
        applyDiscount();
      },
    });
  }

  function updatediscountbar(cart){
    //NO DISCOUNT PRODUCTS
    const nodeListcmm = document.querySelectorAll('.mini-cart__item.nodiscount');
    let totalQuantity = 0;
    let totalPrice = 0;
    nodeListcmm.forEach((nodiscountItem) => {
      const noquantityInput = nodiscountItem.querySelector('.quantity');
      const noquantityValue = parseInt(noquantityInput.value, 10);
      const priceElement = nodiscountItem.querySelector('.mini-cart__item-price .money');
      const priceValue = parseFloat(priceElement.getAttribute('data-price')) / 100;
      totalQuantity += noquantityValue;
      totalPrice += noquantityValue * priceValue;
    });

    //DISCOUNT ITEMS
    const discountItem = document.querySelectorAll('.mini-cart__item.discount');
    let totalQuantity2 = 0;
    let totalPrice2 = 0;
    let diiiii = 0;
    discountItem.forEach((nodiscountItem2) => {
      const noquantityInput2 = nodiscountItem2.querySelector('.quantity');
      const noquantityValue2 = parseInt(noquantityInput2.value, 10);
      const priceElement2 = nodiscountItem2.querySelector('.mini-cart__item-price .money');
      const priceValue2 = parseFloat(priceElement2.getAttribute('data-price')) / 100;
      diiiii = priceValue2;
      totalQuantity2 += noquantityValue2;
      totalPrice2 += noquantityValue2 * priceValue2;
    });
    
    //PACK SAVING PRODUCTS
    const packsaving = document.querySelectorAll('.mini-cart__item.pack-saving-gift');
    let packQuantity = 0;
    let packPrice = 0;
    let cutPrice = 0;
    packsaving.forEach((packsavinglist) => {
      const packsavingInput = packsavinglist.querySelector('.quantity');
      const packsavingValue2 = parseInt(packsavingInput.value, 10);
      const packsavingElement = packsavinglist.querySelector('.package-pricing .money');
      const packsavingunwant = packsavinglist.querySelector('.package-pricing  .pack-updated-gg');
      const packsavingunwantnew = parseFloat(packsavingunwant.getAttribute('data-pack-updated-gg')) / 100;
      const packsavingValue = parseFloat(packsavingElement.getAttribute('data-price')) / 100;
      packQuantity += packsavingValue2;
      packPrice += packQuantity * packsavingValue;
      cutPrice += packQuantity * packsavingunwantnew;
    });
	//alert(cutPrice);
	//FREE PRODUCTS
	const freeGiftItems = document.querySelectorAll('.mini-cart__item.free-gift-item');
    const totalFreeGiftQuantity = freeGiftItems.length;
    let totalFreeGiftPrice = 0;
    freeGiftItems.forEach((item) => {
        const priceElement = item.querySelector('span.money.apnatvv');
        if (priceElement) {
            const priceValue = parseFloat(priceElement.textContent.replace('$', '')); // Remove dollar sign and parse as float
            totalFreeGiftPrice += priceValue; // Add to total
        }
    });
    
     if(nodeListcmm.length > 0){
          const totalItemCount2 = totalQuantity2 - totalFreeGiftQuantity;
          if(packsaving.length > 0){
            // alert('packsaving');
            if (packsaving.length > 0 && totalQuantity2 >= tier_1_line_qnty ) {
                    if (totalQuantity2 >= tier_1_line_qnty && totalQuantity2 < tier_2_line_qnty){
                      //alert('1');
                              $(document).find('.progress-bar-content-item[data-index="2"]').removeClass('active-ico');
                              $(document).find('.progress-bar-content-item[data-index="1"]').addClass('active-ico');
                              $(document).find('.progress-bar-content-item[data-index="3"]').removeClass('active-ico');
                              var getstrike = diiiii - tier_1_dis_amount;
                              $('.mini-cart__item.discount span.apnatvv.strkprcc').html('$' + getstrike.toFixed(2));
                              $('.mini-cart__item.discount .money.apnatvv').addClass('text-strikethrough');
                              $('.mini-cart__item.discount .apnatvv.strkprcc').show();
                              $('.main-subtotal-price').show();
                              $('.cart-total.cart-total-top span.right.cart_subtotal_price_wapper span.money').addClass('text-strikethrough');
                      
                              // Convert the cutPrice and packPrice to numbers by removing the dollar sign and using parseFloat
                              var samplePack = parseFloat(cutPrice.toString().replace('$', '')); // Convert cutPrice to a number
                              var samplePrice = parseFloat(packPrice.toString().replace('$', ''));
                              var packSavingTotal = samplePrice - samplePack;
                              var packSavingsubTotal = parseFloat(packSavingTotal.toString().replace('-', ''));
                              var totalDiscount = totalQuantity2 * tier_1_dis_amount;
                              var finalAmount = packSavingsubTotal + totalDiscount;
                              $('span.memacc-inn-prc').html('- $' + finalAmount.toFixed(2));
                              var cartSubtotal = parseFloat($('span.right.cart_subtotal_price_wapper .money').html().replace('$', ''));
                              var newSubtotal = cartSubtotal - totalDiscount;
                              $('.main-subtotal-price .main-price.oldsum').html('$' + newSubtotal.toFixed(2));
                              
                    }else if (totalQuantity2 >= tier_2_line_qnty && totalQuantity2 < tier_3_line_qnty){
                       //alert('2');
                              $(document).find('.progress-bar-content-item[data-index="2"]').addClass('active-ico');
                              $(document).find('.progress-bar-content-item[data-index="1"]').addClass('active-ico');
                             $(document).find('.progress-bar-content-item[data-index="3"]').removeClass('active-ico');
                             var getstrike = diiiii - tier_2_dis_amount;
                              $('.mini-cart__item.discount span.apnatvv.strkprcc').html('$' + getstrike.toFixed(2));
                              $('.mini-cart__item.discount .money.apnatvv').addClass('text-strikethrough');
                              $('.mini-cart__item.discount .apnatvv.strkprcc').show();
                             $('.main-subtotal-price').show();
                              $('.cart-total.cart-total-top span.right.cart_subtotal_price_wapper span.money').addClass('text-strikethrough');
                      
                              // Convert the cutPrice and packPrice to numbers by removing the dollar sign and using parseFloat
                              var samplePack = parseFloat(cutPrice.toString().replace('$', '')); // Convert cutPrice to a number
                              var samplePrice = parseFloat(packPrice.toString().replace('$', ''));
                              var packSavingTotal = samplePrice - samplePack;
                              var packSavingsubTotal = parseFloat(packSavingTotal.toString().replace('-', ''));
                              var totalDiscount = totalQuantity2 * tier_2_dis_amount;
                              var finalAmount = packSavingsubTotal + totalDiscount;
                              $('span.memacc-inn-prc').html('- $' + finalAmount.toFixed(2));
                              var cartSubtotal = parseFloat($('span.right.cart_subtotal_price_wapper .money').html().replace('$', ''));
                              var newSubtotal = cartSubtotal - totalDiscount;
                              $('.main-subtotal-price .main-price.oldsum').html('$' + newSubtotal.toFixed(2));
                    }else if (totalQuantity2 >= tier_3_line_qnty){
                       //alert('3');
                              $(document).find('.progress-bar-content-item[data-index="2"]').addClass('active-ico');
                              $(document).find('.progress-bar-content-item[data-index="3"]').addClass('active-ico');
                              $(document).find('.progress-bar-content-item[data-index="1"]').addClass('active-ico');
                              var getstrike = diiiii - tier_3_dis_amount;
                              $('.mini-cart__item.discount span.apnatvv.strkprcc').html('$' + getstrike.toFixed(2));
                              $('.mini-cart__item.discount .money.apnatvv').addClass('text-strikethrough');
                              $('.mini-cart__item.discount .apnatvv.strkprcc').show();
                              $('.main-subtotal-price').show();
                              $('.cart-total.cart-total-top span.right.cart_subtotal_price_wapper span.money').addClass('text-strikethrough');
                      
                              // Convert the cutPrice and packPrice to numbers by removing the dollar sign and using parseFloat
                              var samplePack = parseFloat(cutPrice.toString().replace('$', '')); // Convert cutPrice to a number
                              var samplePrice = parseFloat(packPrice.toString().replace('$', ''));
                              var packSavingTotal = samplePrice - samplePack;
                              var packSavingsubTotal = parseFloat(packSavingTotal.toString().replace('-', ''));
                              var totalDiscount = totalQuantity2 * tier_3_dis_amount;
                              var finalAmount = packSavingsubTotal + totalDiscount;
                              $('span.memacc-inn-prc').html('- $' + finalAmount.toFixed(2));
                              var cartSubtotal = parseFloat($('span.right.cart_subtotal_price_wapper .money').html().replace('$', ''));
                              var newSubtotal = cartSubtotal - totalDiscount;
                              $('.main-subtotal-price .main-price.oldsum').html('$' + newSubtotal.toFixed(2));

                    }else if (totalQuantity2 < tier_1_line_qnty ){
                         $('.saving-memacc').hide();  
                         $(document).find('.progress-bar-content-item').removeClass('active-ico');
                  }
              }else if (packsaving.length > 0 && totalQuantity2 < 3) {
                $('.progress-bar-content-item').removeClass('active-ico');
                $('.saving-memacc').hide();
                var samplePack = cutPrice;
                var samplePackDollar = parseFloat(samplePack.toString().replace('$', ''));
                var samplePrice = packPrice;
                var samplePriceDollar = parseFloat(samplePrice.toString().replace('$', ''));
                $('.saving-memacc').show();
                var packSavingTotal = samplePriceDollar - samplePackDollar;
                var cleanedSavingTotal = Math.abs(packSavingTotal).toFixed(2);
                $('span.memacc-inn-prc').html('- $' + cleanedSavingTotal);
              }
          }else{
            //alert('exxceptpacksaving');
              if (nodeListcmm.length > 0 && totalQuantity2 >= tier_1_line_qnty ) {
                    if (totalQuantity2 >= tier_1_line_qnty && totalQuantity2 < tier_2_line_qnty){
                      //alert('come');
                              $(document).find('.progress-bar-content-item[data-index="2"]').removeClass('active-ico');
                              $(document).find('.progress-bar-content-item[data-index="1"]').addClass('active-ico');
                              $(document).find('.progress-bar-content-item[data-index="3"]').removeClass('active-ico');
                              var getstrike = diiiii - tier_1_dis_amount;
                              $('.mini-cart__item.discount span.apnatvv.strkprcc').html('$' + getstrike.toFixed(2));
                              $('.mini-cart__item.discount .money.apnatvv').addClass('text-strikethrough');
                              $('.mini-cart__item.discount .apnatvv.strkprcc').show();
                              var getprc = $('.discount span.money.apnatvv').html();
                              $('.mini-cart__item.discount span.apnatvv.strkprcc').html('$' + getstrike.toFixed(2));
                              $('.main-subtotal-price').show();
                              $('.cart-total.cart-total-top span.right.cart_subtotal_price_wapper span.money').addClass('text-strikethrough');
                              var gettotal = totalQuantity2 * tier_1_dis_amount;
                              $('span.memacc-inn-prc').html('- $' + gettotal.toFixed(2));
                              var getcomes = $('span.right.cart_subtotal_price_wapper .money').html();
                              var priceWithoutDollar2 = getcomes.replace('$', '');
                              var outcome = priceWithoutDollar2 - gettotal;
                              $('.main-subtotal-price  .main-price.oldsum').html('$'+outcome.toFixed(2));

                              if(totalQuantity2 == '1' ){
                              $('.offer-unlock').html('Add 2 more for your first bundle 🎯');
                              }else if(totalQuantity2 == '2' ){
                                $('.offer-unlock').html('Just 1 more to lock it in 🔥');
                              }else if(totalQuantity2 == '3' ){
                                $('.offer-unlock').html('🎉 Deal unlocked! Add 3 more for our most popular deal');
                              }else if(totalQuantity2 == '4' ){
                                $('.offer-unlock').html('Super close. 2 more to get there 👀');
                              }else if(totalQuantity2 == '5' ){
                                $('.offer-unlock').html('Add 1 more. It’s basically free. 😉');
                              }
                    }else if (totalQuantity2 >= tier_2_line_qnty && totalQuantity2 < tier_3_line_qnty){
                              $(document).find('.progress-bar-content-item[data-index="2"]').addClass('active-ico');
                              $(document).find('.progress-bar-content-item[data-index="1"]').addClass('active-ico');
                             $(document).find('.progress-bar-content-item[data-index="3"]').removeClass('active-ico');
                             var getstrike = diiiii - tier_2_dis_amount;
                             $('.mini-cart__item.discount span.apnatvv.strkprcc').html('$' + getstrike.toFixed(2));
                              $('.mini-cart__item.discount .money.apnatvv').addClass('text-strikethrough');
                              $('.mini-cart__item.discount .apnatvv.strkprcc').show();
                              $('.main-subtotal-price').show();
                              $('.cart-total.cart-total-top span.right.cart_subtotal_price_wapper span.money').addClass('text-strikethrough');
                              var gettotal = totalQuantity2 * tier_2_dis_amount;
                              $('span.memacc-inn-prc').html('- $' + gettotal.toFixed(2));
                              var getcomes = $('span.right.cart_subtotal_price_wapper .money').html();
                              var priceWithoutDollar2 = getcomes.replace('$', '');
                              var outcome = priceWithoutDollar2 - gettotal;
                              $('.main-subtotal-price  .main-price.oldsum').html('$'+outcome.toFixed(2));

                              if(totalQuantity2 == '6' ){
                                $('.offer-unlock').html('🔥 Most popular deal unlocked! Add 2 more for best value');
                              }else if(totalQuantity2 == '7' ){
                                $('.offer-unlock').html('Last step. 1 more for lowest price per item ⭐');
                              }
                    }else if (totalQuantity2 >= tier_3_line_qnty){
                              $(document).find('.progress-bar-content-item[data-index="2"]').addClass('active-ico');
                              $(document).find('.progress-bar-content-item[data-index="3"]').addClass('active-ico');
                              $(document).find('.progress-bar-content-item[data-index="1"]').addClass('active-ico');
                              var getstrike = diiiii - tier_3_dis_amount;
                              $('.mini-cart__item.discount span.apnatvv.strkprcc').html('$' + getstrike.toFixed(2));
                              $('.mini-cart__item.discount .money.apnatvv').addClass('text-strikethrough');
                              $('.mini-cart__item.discount .apnatvv.strkprcc').show();
                              $('.main-subtotal-price').show();
                              $('.cart-total.cart-total-top span.right.cart_subtotal_price_wapper span.money').addClass('text-strikethrough');
                              var gettotal = totalQuantity2 * tier_3_dis_amount;
                              $('span.memacc-inn-prc').html('- $' + gettotal.toFixed(2));
                              var getcomes = $('span.right.cart_subtotal_price_wapper .money').html();
                              var priceWithoutDollar2 = getcomes.replace('$', '');
                              var outcome = priceWithoutDollar2 - gettotal;
                              $('.main-subtotal-price  .main-price.oldsum').html('$'+outcome.toFixed(2));

                              if(totalQuantity2 == '8' ){
                                $('.offer-unlock').html('🏆 Best value unlocked. Lowest price per item');
                              }
                    }else if (totalQuantity2 < tier_1_line_qnty ){
                         $('.saving-memacc').hide();  
                         $(document).find('.progress-bar-content-item').removeClass('active-ico');
                  }
              }else if (nodeListcmm.length > 0 && totalQuantity2 < 3) {
                $('.progress-bar-content-item').removeClass('active-ico');
                $('.saving-memacc').hide();
                // $('a.js-cart-remove-btn.cart__remove-btn.free-gift-remove').click();
              }
          }
     }else {
         //alert('3');
             const totalItemCount = cart.item_count - totalFreeGiftQuantity;
             if (totalItemCount >= tier_1_line_qnty && totalItemCount < tier_2_line_qnty){
                      $(document).find('.progress-bar-content-item[data-index="2"]').removeClass('active-ico');
                      $(document).find('.progress-bar-content-item[data-index="1"]').addClass('active-ico');
                      $(document).find('.progress-bar-content-item[data-index="3"]').removeClass('active-ico');
                      var getstrike = diiiii - tier_1_dis_amount;
                      $('.mini-cart__item.discount span.apnatvv.strkprcc').html('$' + getstrike.toFixed(2));
                      $('.mini-cart__item.discount .money.apnatvv').addClass('text-strikethrough');
                      $('.mini-cart__item.discount .apnatvv.strkprcc').show();
                      var getprc = $('.discount span.money.apnatvv').html();
                      // Remove the dollar sign and convert to a number
                      var priceWithoutDollar = getprc.replace('$', '');
                      var numericPrice = parseFloat(priceWithoutDollar);
                      var newgetprc = numericPrice - tier_1_dis_amount;
                      var tillget = newgetprc.toFixed(2) * totalItemCount;
                      $('.cart-total.cart-total-top span.right.cart_subtotal_price_wapper span.money').addClass('text-strikethrough');
                      $('.main-subtotal-price').show();
                      var newtotal = $('span.right.cart_subtotal_price_wapper span.money').html();
                      var priceWithoutDollar2 = newtotal.replace('$', '');
                      var priceWithoutDollar2up = priceWithoutDollar2
                      var newsaved = priceWithoutDollar2 - tillget;
                      $('.main-subtotal-price  .main-price.oldsum').html('$'+tillget);

                      if(totalItemCount == '3' ){
                        $('.offer-unlock').html('🎉 Deal unlocked! Add 3 more for our most popular deal');
                      }else if(totalItemCount == '4' ){
                        $('.offer-unlock').html('Super close. 2 more to get there 👀');
                      }else if(totalItemCount == '5' ){
                        $('.offer-unlock').html('Add 1 more. It’s basically free. 😉');
                      }
            }else if (totalItemCount >= tier_2_line_qnty && totalItemCount < tier_3_line_qnty){
                      $(document).find('.progress-bar-content-item[data-index="2"]').addClass('active-ico');
                      $(document).find('.progress-bar-content-item[data-index="1"]').addClass('active-ico');
                      $(document).find('.progress-bar-content-item[data-index="3"]').removeClass('active-ico');
                      var getstrike = diiiii - tier_2_dis_amount;
                      $('.mini-cart__item.discount span.apnatvv.strkprcc').html('$' + getstrike.toFixed(2));
                      $('.mini-cart__item.discount .money.apnatvv').addClass('text-strikethrough');
                      $('.mini-cart__item.discount .apnatvv.strkprcc').show();
                      var getprc = $('.discount span.money.apnatvv').html();
                      // Remove the dollar sign and convert to a number
                      var priceWithoutDollar = getprc.replace('$', '');
                      var numericPrice = parseFloat(priceWithoutDollar);
                      var newgetprc = numericPrice - tier_2_dis_amount;
                      var tillget = newgetprc.toFixed(2) * totalItemCount;
                      $('.cart-total.cart-total-top span.right.cart_subtotal_price_wapper span.money').addClass('text-strikethrough');
                      $('.main-subtotal-price').show();
                      var newtotal = $('span.right.cart_subtotal_price_wapper span.money').html();
                      var priceWithoutDollar2 = newtotal.replace('$', '');
                      var priceWithoutDollar2up = priceWithoutDollar2
                      var newsaved = priceWithoutDollar2 - tillget;
                      $('.main-subtotal-price  .main-price.oldsum').html('$'+tillget);
                      if (totalItemCount == tier_2_line_qnty){
                      $('.main-subtotal-price  .main-price.oldsum').html('$'+tillget.toFixed(0));
                      }else{
                      $('.main-subtotal-price  .main-price.oldsum').html('$'+tillget.toFixed(2));  
                      }

                      if(totalItemCount == '6' ){
                        $('.offer-unlock').html('🔥 Most popular deal unlocked! Add 2 more for best value');
                      }else if(totalItemCount == '7' ){
                        $('.offer-unlock').html('Last step. 1 more for lowest price per item ⭐');
                      }
            }else if (totalItemCount >= tier_3_line_qnty){
                      $(document).find('.progress-bar-content-item[data-index="2"]').addClass('active-ico');
                      $(document).find('.progress-bar-content-item[data-index="3"]').addClass('active-ico');
                      $(document).find('.progress-bar-content-item[data-index="1"]').addClass('active-ico');
                      var getstrike = diiiii - tier_3_dis_amount;
                      $('.mini-cart__item.discount span.apnatvv.strkprcc').html('$' + getstrike.toFixed(2));
                      $('.mini-cart__item.discount .money.apnatvv').addClass('text-strikethrough');
                      $('.mini-cart__item.discount .apnatvv.strkprcc').show();
                      var getprc = $('.discount span.money.apnatvv').html();
                      // Remove the dollar sign and convert to a number
                      var priceWithoutDollar = getprc.replace('$', '');
                      var numericPrice = parseFloat(priceWithoutDollar);
                      var newgetprc = numericPrice - tier_3_dis_amount;
                      var tillget = newgetprc.toFixed(2) * totalItemCount;
                      $('.cart-total.cart-total-top span.right.cart_subtotal_price_wapper span.money').addClass('text-strikethrough');
                      $('.main-subtotal-price').show();
                      var newtotal = $('span.right.cart_subtotal_price_wapper span.money').html();
                      var priceWithoutDollar2 = newtotal.replace('$', '');
                      var priceWithoutDollar2up = priceWithoutDollar2
                      var newsaved = priceWithoutDollar2 - tillget;
                      $('.main-subtotal-price  .main-price.oldsum').html('$'+tillget);
                      if (totalItemCount == tier_3_line_qnty){
                        $('.main-subtotal-price  .main-price.oldsum').html('$'+tillget.toFixed(0));
                      }else{
                        $('.main-subtotal-price  .main-price.oldsum').html('$'+tillget.toFixed(2));  
                      }

                      if(totalItemCount == '8' ){
                        $('.offer-unlock').html('🏆 Best value unlocked. Lowest price per item');
                      }
            }else if (totalItemCount < tier_1_line_qnty ){
                 $('.saving-memacc').hide();  
                 $(document).find('.progress-bar-content-item').removeClass('active-ico'); 
                 if(totalItemCount == '1' ){
                  $('.offer-unlock').html('Add 2 more for your first bundle 🎯');
                  }else if(totalItemCount == '2' ){
                    $('.offer-unlock').html('Just 1 more to lock it in 🔥');
                  }
          }

    }
  }
  function updateshippingbar(cart){
    var freeshpamm = $('.main-price.oldsum span.money').html();
        var freeshpamm = $('.main-price.oldsum').text();
        var priceWithDollar = parseFloat(freeshpamm.replace('$', '')); // Convert to float 

        // Define the free shipping threshold
        const freeShippingThreshold = 25;
        // Calculate the progress percentage
        const progressPercentage = Math.min((priceWithDollar / freeShippingThreshold) * 100, 100); // Limit to 100%
        // Determine if the threshold is reached
        if (priceWithDollar >= freeShippingThreshold) {
            // If the threshold is reached or exceeded
            const amountRemaining = 0; // No amount remaining when threshold is met
            $(document).find('.progress-bar-fill').css('width', '100%'); // Fill progress bar completely
            $(document).find('.progress-bar-fill').addClass('progress-bar-final');
            $(document).find('.shipping-amt').html('🎉 Congratulations! You have FREE SHIPPING!');
        } else {
            // If the threshold is not yet reached
            const amountRemaining = freeShippingThreshold - priceWithDollar; // Amount remaining to reach threshold
            $(document).find('.progress-bar-fill').css('width', progressPercentage + '%'); // Set progress bar width
            $(document).find('.progress-bar-fill').removeClass('progress-bar-final');
            $(document).find('.shipping-amt').html('Add $' + amountRemaining.toFixed(2) + ' more for FREE Shipping 🚚');
        }
  }
  function freebeavaiability(cart) {
                 var freeshpamm2 = $('.main-price.oldsum span.money').html(); // Use only one line to get the text
                 var freeshpamm2 = $('.main-price.oldsum').text();
                  // Convert price to float, removing dollar sign and trimming spaces
                  var priceWithDollar2 = parseFloat(freeshpamm2.replace('$', '').trim()); 
              
                  // Check for valid number after conversion
                  if (isNaN(priceWithDollar2)) {
                      return;
                  }
                  
                  // Define the free shipping threshold and logic
                  if (priceWithDollar2 >= 0 && priceWithDollar2 < 35) {
                      $('.cart-free-gift-items.first-freeproduct').removeClass('remove-freebe');
                      $('.cart-free-gift-items.first-freeproduct').removeClass('freebe-enable');
                      $('.cart-free-gift-items.first-freeproduct').addClass('grayoutbtn');
                      $('.cart-free-gift-items.second-freeproduct').addClass('grayoutbtn remove-freebe');
                      $('.cart-free-gift-items.third-freeproduct').addClass('grayoutbtn remove-freebe');
                      $('.cart-free-gift-items.fourth-freeproduct').addClass('grayoutbtn remove-freebe');
                      $('li.mini-cart__item.free-gift-item.Xpand.Quick.Wipes a.js-cart-remove-btn.cart__remove-btn.free-gift-remove').click();
                      $('li.mini-cart__item.free-gift-item.thirdFreebe-item a.js-cart-remove-btn.cart__remove-btn.free-gift-remove').click();
                      $('li.mini-cart__item.free-gift-item.Freebe-item a.js-cart-remove-btn.cart__remove-btn.free-gift-remove').click();
                      $('li.mini-cart__item.free-gift-item.fourthFreebe-item a.js-cart-remove-btn.cart__remove-btn.free-gift-remove').click();
                  } else if (priceWithDollar2 >= 35 && priceWithDollar2 < 60) {
                      $('.cart-free-gift-items.first-freeproduct').removeClass('grayoutbtn remove-freebe');
                      $('.cart-free-gift-items.first-freeproduct').addClass('freebe-enable');
                      $('.cart-free-gift-items.second-freeproduct').addClass('grayoutbtn remove-freebe');
                      $('.cart-free-gift-items.third-freeproduct').addClass('grayoutbtn remove-freebe');
                      $('.cart-free-gift-items.fourth-freeproduct').addClass('grayoutbtn remove-freebe');
                      $('.cart-free-gift-items.second-freeproduct').removeClass('freebe-enable');
                      $('li.mini-cart__item.free-gift-item.fourthFreebe-item a.js-cart-remove-btn.cart__remove-btn.free-gift-remove').click();
                      $('li.mini-cart__item.free-gift-item.Xpand.Quick.Wipes a.js-cart-remove-btn.cart__remove-btn.free-gift-remove').click();
                  } else if (priceWithDollar2 >= 60 && priceWithDollar2 < 75) {
                      $('.cart-free-gift-items.first-freeproduct').removeClass('grayoutbtn remove-freebe');
                      $('.cart-free-gift-items.second-freeproduct').removeClass('grayoutbtn remove-freebe');
                      $('.cart-free-gift-items.second-freeproduct').addClass('freebe-enable');
                      $('.cart-free-gift-items.third-freeproduct').addClass('grayoutbtn remove-freebe');
                      $('.cart-free-gift-items.third-freeproduct').removeClass('freebe-enable');
                      $('.cart-free-gift-items.fourth-freeproduct').addClass('grayoutbtn remove-freebe');
                      $('li.mini-cart__item.free-gift-item.Freebe-item a.js-cart-remove-btn.cart__remove-btn.free-gift-remove').click();
                  } else if (priceWithDollar2 >= 75 && priceWithDollar2 < 95) {
                      $('.cart-free-gift-items.first-freeproduct').removeClass('grayoutbtn remove-freebe');
                      $('.cart-free-gift-items.second-freeproduct').removeClass('grayoutbtn remove-freebe');
                      $('.cart-free-gift-items.second-freeproduct').addClass('freebe-enable');
                      $('.cart-free-gift-items.third-freeproduct').removeClass('grayoutbtn remove-freebe ');
                      $('.cart-free-gift-items.third-freeproduct').addClass('freebe-enable');
                      $('.cart-free-gift-items.fourth-freeproduct').addClass('grayoutbtn remove-freebe');
                      $('li.mini-cart__item.free-gift-item.Xpand.Quick.Wipes a.js-cart-remove-btn.cart__remove-btn.free-gift-remove').click();
                  } else if (priceWithDollar2 >= 95 ) {
                      $('.cart-free-gift-items.first-freeproduct').removeClass('grayoutbtn remove-freebe');
                      $('.cart-free-gift-items.second-freeproduct').removeClass('grayoutbtn remove-freebe');
                      $('.cart-free-gift-items.third-freeproduct').removeClass('grayoutbtn remove-freebe');
                      $('.cart-free-gift-items.fourth-freeproduct').removeClass('grayoutbtn remove-freebe');
                      $('.cart-free-gift-items.fourth-freeproduct').addClass('freebe-enable');
                  }
  }
  $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
                refreshCart(cart);
            },
  });
  function applyDiscount(){
      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        cache: false,
        success(cartData) {
          //console.log('Get Updated Cart==>', cartData);
          toAppendtagsonCartUpdate();
          $('.cart_items__content__wrapper').animate({ scrollTop: 0  }, 'slow');
        },
        error(XMLHttpRequest) {
          console.log('Get Updated Cart Error==>', XMLHttpRequest);
        }
      });
    }  
    function toAppendtagsonCartUpdate(){      
      $(document).find('#temp-cart-data').remove();
      $.ajax({
        type: 'GET',
        url: '/cart?view=temp',
        cache: false,
        async:false,
        success(cartTempData) {
          $('body').append(cartTempData);
          var updateDataAttr = setInterval(function(){
            if($('body').find('#temp-cart-data').length > 0 ){
              $('#temp-cart-data .cart-temp-data').each(function(){
                $(document).find('.cart_items.js-cart_items li[data-line-id="'+$(this).attr('data-line-id')+'"]').attr('data-tags', $(this).attr('data-tags'));
                if($(this).attr('data-free-product')){
                  $(document).find('.cart_items.js-cart_items li[data-line-id="'+$(this).attr('data-line-id')+'"]').attr('data-free-product', $(this).attr('data-free-product'));
                  if($(this).attr('data-tags') == 'BOGOOFF'){
                    $(this).removeAttr('data-tags');
                  }
                }                
              })
              clearInterval(updateDataAttr);
            }
          },100);
        },
        error(XMLHttpRequest) {
          console.log('Get Updated cartTempData Error==>', XMLHttpRequest);
        }
      });
    }  
}
});